/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const importedEntrySchema = z.object({
  date: z.string().date().optional(),
  hours: z.coerce.number().optional(),
});
